import VerofreshRecord from './VerofreshRecord'
import RouteViolationRecord from './RouteViolationRecord'
import NotificationRecord from './NotificationRecord'

class NotificationRuleRecord extends VerofreshRecord {
  /**
   * Returns an array of strings representing durations to wait before a
   * notification rule is triggered
   *
   * @return {Array<String>}
   */
  static getRulesOptions () {
    return [
      'duration:0 seconds',
      'duration:20 minutes',
      'duration:30 minutes',
      'duration:60 minutes',
      'duration:120 minutes'
    ]
  }

  /**
   * Returns an array of different violation events the user can subscribe to.
   *
   * @return {Array<String>}
   */
  static getEventOptions () {
    return [
      `${RouteViolationRecord.LEVEL_FATAL}_violation:all`,
      `${RouteViolationRecord.LEVEL_FATAL}_violation:${RouteViolationRecord.TYPE_COLD}`,
      `${RouteViolationRecord.LEVEL_FORECAST}_violation:${RouteViolationRecord.TYPE_COLD}`,
      `${RouteViolationRecord.LEVEL_FORECAST_STAGING}_violation:${RouteViolationRecord.TYPE_COLD}`,
      `${RouteViolationRecord.LEVEL_FATAL}_violation:${RouteViolationRecord.TYPE_HOT}`,
      `${RouteViolationRecord.LEVEL_FORECAST}_violation:${RouteViolationRecord.TYPE_HOT}`,
      `${RouteViolationRecord.LEVEL_FORECAST_STAGING}_violation:${RouteViolationRecord.TYPE_HOT}`,
      `${RouteViolationRecord.LEVEL_FATAL}_violation:${RouteViolationRecord.TYPE_NODATA}`,
      `${RouteViolationRecord.LEVEL_FATAL}_violation:${RouteViolationRecord.TYPE_GAP}`,
      'route_plan_upload_failed',
      'route_plan_upload_partial_failure'
    ]
  }

  /**
   * Returns a string identifying the level of event (e.g. forecast, fatal,
   * etc..) corresponding to RouteViolationRecord.LEVEL_* constants
   *
   * @param {String} event
   */
  static getEventLevel (event) {
    if (typeof event !== 'string') {
      return undefined
    }

    // Route plan upload events don't have a level
    if (event.startsWith('route_plan_upload')) {
      return 'route_plan_upload'
    }

    const matches = event.match(/(.*)_violation:/i)

    if (matches && matches.length === 2) {
      return matches[1]
    }

    return undefined
  }

  /**
   * Returns an array of the ways notifications can be delivered (currently only
   * email)
   *
   * @return {Array<String>}
   */
  static getDeliveryOptions () {
    return [
      NotificationRecord.TYPE_EMAIL
    ]
  }
}

export default NotificationRuleRecord
